"use client";

import React, { useState, useEffect } from 'react';
import { EnvironmentIndicator } from '@/components/ui/environment-indicator';
import { Button } from '@/components/ui/button';
import { ChevronUp, ChevronDown, Info } from 'lucide-react';

export function EnvironmentFooter() {
  const [isExpanded, setIsExpanded] = useState(false);

  // Add bottom padding to body when footer is present
  useEffect(() => {
    const body = document.body;
    body.style.paddingBottom = isExpanded ? '120px' : '60px';
    
    return () => {
      body.style.paddingBottom = '';
    };
  }, [isExpanded]);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="flex items-center justify-between px-4 py-2">
        <EnvironmentIndicator variant="compact" />
        
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-gray-600 hover:text-gray-800"
        >
          <Info className="w-4 h-4 mr-2" />
          Environment Info
          {isExpanded ? (
            <ChevronDown className="w-4 h-4 ml-2" />
          ) : (
            <ChevronUp className="w-4 h-4 ml-2" />
          )}
        </Button>
      </div>

      {isExpanded && (
        <div className="border-t border-gray-200 bg-gray-50 px-4 py-3">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
            <div>
              <span className="font-medium text-gray-700">Environment:</span>
              <span className="ml-2 text-gray-600">
                {process.env.NEXT_PUBLIC_ENV_NAME || 'Unknown'}
              </span>
            </div>
            <div>
              <span className="font-medium text-gray-700">Database:</span>
              <span className="ml-2 text-gray-600">
                {process.env.NEXT_PUBLIC_DB_NAME || 'Unknown'}
              </span>
            </div>
            <div>
              <span className="font-medium text-gray-700">Node ENV:</span>
              <span className="ml-2 text-gray-600">
                {process.env.NODE_ENV || 'Unknown'}
              </span>
            </div>
            <div className="col-span-1 md:col-span-2 lg:col-span-1">
              <span className="font-medium text-gray-700">NextAuth URL:</span>
              <span className="ml-2 text-gray-600 text-xs">
                {typeof window !== 'undefined' ? window.location.origin : process.env.NEXTAUTH_URL || 'Not set'}
              </span>
            </div>
            <div className="col-span-1 md:col-span-2 lg:col-span-1">
              <span className="font-medium text-gray-700">Gateway URL:</span>
              <span className="ml-2 text-gray-600 text-xs">
                {process.env.NEXT_PUBLIC_SECUREGATEWAY_URL || 'Not set'}
              </span>
            </div>
            <div>
              <span className="font-medium text-gray-700">Build ID:</span>
              <span className="ml-2 text-gray-600 text-xs font-mono">
                {process.env.NEXT_PUBLIC_BUILD_ID || 'Not set'}
              </span>
            </div>
            <div>
              <span className="font-medium text-gray-700">Build Time:</span>
              <span className="ml-2 text-gray-600 text-xs">
                {process.env.NEXT_PUBLIC_BUILD_TIMESTAMP || 'Not set'}
              </span>
            </div>
          </div>
          <div className="mt-3 pt-3 border-t border-gray-300">
            <div className="text-xs text-gray-500 flex items-center justify-between">
              <span>🔧 Development Tools - Hidden in Production</span>
              <span>Press F12 for Browser DevTools</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
